// extracted by mini-css-extract-plugin
export default {"container":"ConstraintTooltip_container__lW4D+","symbol":"ConstraintTooltip_symbol__TO2F+"};